<template>
  <div v-if="!isProductAvailable" class="product-unavailable-message-outer" :class="{ 'content-justification-override': !isUpdatedGallery }">
    <div class="product-unavailable-message-inner">
      <p class="message">Sorry, this item is currently unavailable in {{formattedCountryName()}}.</p>
    </div>
  </div>
</template>

<script>
import CountryUtils from '../commons/CountryUtils.js';
import LocationService from '@/services/LocationService';

export default {
  name: 'ProductUnavailableMessage',
  props: {
    isProductAvailable: {
      type: Boolean,
      default: true
    },
    isUpdatedGallery: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formattedCountryName() {
      return CountryUtils.getFormattedCountryNameByCurrencyId(LocationService.getCurrencyId());
    }
  }
};
</script>

<style lang="postcss" scoped>
@import '@/pixel/style/variables';
@import '@/pixel/style/mixins';

.content-justification-override {
  justify-content: flex-start !important;
  @media (max-width: $tablet-breakpoint) {
    justify-content: center !important;
  }
}

.product-unavailable-message-outer {
  display: flex;
  @media (min-width: $desktop-breakpoint) {
    justify-content: flex-start;
  }
  box-sizing: border-box;
  @media (min-width: $mobile-breakpoint) and (max-width: $desktop-breakpoint) {
    justify-content: center;
  }
  margin-top:8px;

  .product-unavailable-message-inner {
    background: var(--coral-light);
    border-radius: 4px;

    .message {
      color: var(--coral);
      margin-bottom: 0 !important;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 125%;
      @media (min-width: 310px) and (max-width: 375px) {
        padding:8px 24px !important;
        text-align: center;
      }
      padding:8px 12px !important;
    }
  }
}
</style>